import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentSummitPulseTeamMemberOverview on SummitPulseTeamMemberOverview {
    name
    highlight
    concern
  }
`
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentSummitPulseTeamMemberOverviewFragment,
  ents.core.summit.Pulse.TeamMemberOverview
>({
  concern: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    TypeAsserter.assertIsNotNullish,
    {
      warnOnly: true,
    },
  ),
  highlight: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    TypeAsserter.assertIsNotNullish,
    {
      warnOnly: true,
    },
  ),
  name: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    TypeAsserter.assertIsNotNullish,
    {
      warnOnly: true,
    },
  ),
})
